<template>
  <div>
    <v-alert
      v-if="error.show"
      border="left"
      elevation="2"
      class="mx-2"
      colored-border
      type="error"
      dismissible
      @input="error.show = false"
    >
      {{ error.text }}
    </v-alert>
    <v-alert
      v-if="warning.show"
      border="left"
      elevation="2"
      class="mx-2"
      colored-border
      type="warning"
      dismissible
      @input="warning.show = false"
    >
      {{ warning.text }}
    </v-alert>
    <v-alert
      v-if="message.show"
      border="left"
      elevation="2"
      class="mx-2"
      type="info"
      colored-border
      dismissible
      color="primary"
      @input="message.show =false"
    >
      {{ message.text }}
    </v-alert>
  </div>
</template>

<script>

export default {

   data: function () {
      return {

      }
   },
   computed: {
      error () {
         return {
            show: !!this.$page.props.flash.error,
            text: this.$page.props.flash.error
         }
      },
      warning () {
         return {
            show: !!this.$page.props.flash.warning,
            text: this.$page.props.flash.warning
         }
      },
      message () {
         return {
            show: !!this.$page.props.flash.message,
            text: this.$page.props.flash.message
         }
      }
   }
}
</script>
